export const types = {
  ADD_TO_CART: "[Shop] ADD_TO_CART",
  REMOVE_FROM_CART: "[Shop] REMOVE_FROM_CART",
  ADJUST_QUANTITY: "[Shop] ADJUST_QUANTITY",
  LOAD_CURRENT_ITEM: "[Shop] LOAD_CURRENT_ITEM",
  EMPTY_CART: "[Shop] EMPTY_CART",
  NEW_ORDER: "[Shop] NEW_ORDER",
  GET_ORDERS: "[Shop] GET_ORDERS",
};
